export default {
  LOAD_SHARED_USERS (state, payload) {
    state.sharedWithUsers = payload
    if (!state.sharedWithUsers) {
      state.sharedWithUsers = []
    }
  },
  LOAD_SHARED_GROUPS (state, payload) {
    state.sharedWithGroups = payload
    if (!state.sharedWithGroups) {
      state.sharedWithGroups = []
    }
  },
  LOAD_SHARED_ENTITY (state, payload) {
    state.sharedEntity = payload
  }
}



// WEBPACK FOOTER //
// ./src/app/sharing/vuex/mutations.js